import {createActions} from 'redux-actions';
import fetchJson, {deleteJson, postJson} from '../fetchJson';
import handleError from '../handleError';
import uiActions from '../chrome/ui.actions';

const actions = createActions(
	'NOTIFICATIONS_RETRIEVING',
	'NOTIFICATIONS_RECEIVED',
	'NOTIFICATIONS_ADD',
	'NOTIFICATIONS_DISMISS',
	'NOTIFICATIONS_MARK_ALL_VIEWED'
);

export const requestNotificationPermission = () => {
	if (
		'Notification' in window &&
		process.env.NODE_ENV !== 'test' &&
		Notification.permission === 'default'
	) {
		try {
			Notification.requestPermission();
		} catch (e) {
			console.error(e); // Ignore browser notification errors
		}
	}
};

export const retrieveNotifications = () => (dispatch, getState) => {
	dispatch(actions.notificationsRetrieving());
	fetchJson('/api/notifications')
		.then(notifications => {
			dispatch(actions.notificationsReceived(notifications));
		})
		.catch(handleError(dispatch));
};

export const addNotification = data => dispatch => {
	const currentlyViewingChat = data.type === 'chat' && window.location.pathname === data.href;

	// dont create notification for chat if we are currently viewing that chat
	if (!currentlyViewingChat) {
		dispatch(actions.notificationsAdd(data));
		notifyBrowser(data, dispatch);
	}
};

const notifyBrowser = (data, dispatch) => {
	try {
		if (!('Notification' in window)) return false;

		if (Notification.permission === 'granted') {
			createBrowserNotification(data, dispatch);
		} else if (Notification.permission !== 'denied') {
			Notification.requestPermission(permission => {
				if (permission === 'granted') {
					createBrowserNotification(data, dispatch);
				}
			});
		}
	} catch (e) {
		console.error(e); // Ignore browser notification errors
	}
};

const createBrowserNotification = (data, dispatch) => {
	try {
		const notification = new Notification(data.title);
		notification.onclick = () => dispatch(uiActions.showUserMenu());
	} catch (e) {
		console.error(e); // Ignore browser notifcation errors
	}
};

const dismissNotification = (type, key) => dispatch => {
	deleteJson(`/api/notifications/${type}/${encodeURIComponent(key)}`)
		.then(() => {
			dispatch(actions.notificationsDismiss({type, key}));
		})
		.catch(handleError(dispatch));
};

/**
 * Dismiss chat notification only if it hasn't already been viewed. This may be
 * called multiple times for the same chat so it shouldn't throw an error if
 * the chat notif has already been dismissed
 */
const dismissChatNotification = key => (dispatch, getState) => {
	const {notifications} = getState();

	if (!notifications.items || notifications.fetching) return;

	notifications.items.forEach(notification => {
		if (notification.type === 'chat' && notification.key === key && !notification.viewed) {
			deleteJson(`/api/notifications/chat/${encodeURIComponent(key)}`)
				.then(() => {
					dispatch(actions.notificationsDismiss({type: 'chat', key}));
				})
				.catch(err => {}); // ignore error
		}
	});
};

const markAllViewed = () => dispatch => {
	postJson('/api/notifications/viewed', {})
		.then(() => {
			dispatch(actions.notificationsMarkAllViewed());
		})
		.catch(handleError(dispatch));
};

const acceptNotification = (type, key) => dispatch => {
	if (type === 'communityInvite') {
		postJson(`/api/community/${key.split('invite.')[1]}/accept`, {})
			.then(() =>
				dispatch(
					uiActions.uiMessage(`You are now a member of a community. Browse around and have a look!`)
				)
			)
			.then(() => dispatch(dismissNotification(type, key)))
			.catch(handleError(dispatch));
	}
};

export default {
	...actions,
	requestNotificationPermission,
	retrieveNotifications,
	addNotification,
	acceptNotification,
	dismissNotification,
	markAllViewed,
	dismissChatNotification
};



// WEBPACK FOOTER //
// ./src/user/notifications.actions.js